export const API_URL =
  window?.__ENV__?.REACT_APP_API_URL ?? process?.env?.REACT_APP_API_URL
